"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
var _mockjs = _interopRequireDefault(require("mockjs"));
const NameList = [];
const count = 100;
for (let i = 0; i < count; i++) {
  NameList.push(_mockjs.default.mock({
    name: '@first'
  }));
}
NameList.push({
  name: 'mock-Pan'
});
var _default = exports.default = [
// username search
{
  url: '/vue-element-admin/search/user',
  type: 'get',
  response: config => {
    const {
      name
    } = config.query;
    const mockNameList = NameList.filter(item => {
      const lowerCaseName = item.name.toLowerCase();
      return !(name && lowerCaseName.indexOf(name.toLowerCase()) < 0);
    });
    return {
      code: 20000,
      data: {
        items: mockNameList
      }
    };
  }
},
// transaction list
{
  url: '/vue-element-admin/transaction/list',
  type: 'get',
  response: _ => {
    return {
      code: 20000,
      data: {
        total: 20,
        'items|20': [{
          order_no: '@guid()',
          timestamp: +_mockjs.default.Random.date('T'),
          username: '@name()',
          price: '@float(1000, 15000, 0, 2)',
          'status|1': ['success', 'pending']
        }]
      }
    };
  }
}];